import { useEffect, useState } from "react";

export const useDebouncedState = <T>(value: T, timeoutInMs: number = 500) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), timeoutInMs);

    return () => clearTimeout(timeout);
  }, [value, timeoutInMs]);

  return { debouncedValue };
};
